import { graphql, useStaticQuery } from 'gatsby';

const useCheckoutUrlQuery = () => {
    const { application } = useStaticQuery(
        graphql`
            {
                application {
                    data {
                        config {
                            dedicatedPages {
                                checkoutResponsePage
                                checkoutPage
                            }
                        }
                    }
                }
            }
        `
    );
    return application.data.config.dedicatedPages || {};
};

export default useCheckoutUrlQuery;
